export default "__VITE_ASSET__DkpJwFZ5__"